import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var linearTagInverseIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.752 8.246 16.731 9.27c-.65.65-1.67.68-2.358.105l-.115-.105h-.01a1.769 1.769 0 0 1-.104-2.373l.105-.115 1.709-1.713c-.143-.02-.296-.048-.449-.048-1.661 0-3.007 1.35-3.007 3.014s1.346 3.015 3.007 3.015 3.007-1.35 3.007-3.015a2.8 2.8 0 0 0-.048-.497l-.716.718v-.01Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.175 6.82c.124.383.21.785.21 1.215 0 2.144-1.738 3.895-3.886 3.895s-3.885-1.741-3.885-3.895 1.747-3.894 3.885-3.894c.41 0 .802.086 1.175.2L19.27 1.74l-7.35-.02a1.48 1.48 0 0 0-1.041.431l-9.947 9.98a1.458 1.458 0 0 0-.115 1.943l.096.105 8.42 8.44a1.446 1.446 0 0 0 1.938.087l.114-.096 9.957-9.981c.239-.24.391-.555.42-.9V4.217l-2.578 2.584-.01.019Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.503.675c-.325 0-.721.124-.989.344l-.114.096-3.656 3.665-.64.642-.945.947-1.108 1.11a.717.717 0 0 0-.066.938l.066.077h.01a.701.701 0 0 0 .935.076l.077-.067 1.117-1.11.954-.957.2-.201.44-.44 3.055-3.062 1.66-1.666a1.458 1.458 0 0 0-.84-.392"
}));

export { linearTagInverseIcon as default };
//# sourceMappingURL=linearTagInverseIcon.js.map
